/**
 * Comma-delimited search terms: everything between commas is one phrase
 * (spaces kept). Empty segments after trim are dropped.
 */
export function parseCommaDelimitedSearchTerms(search: string): string[] {
  return search
    .split(",")
    .map((t) => t.trim().toLowerCase())
    .filter((t) => t.length > 0);
}

/** True when haystack contains every comma-delimited phrase (AND). Empty search matches all. */
export function haystackMatchesCommaSearch(haystack: string, search: string): boolean {
  const terms = parseCommaDelimitedSearchTerms(search);
  if (terms.length === 0) return true;
  const hay = haystack.toLowerCase();
  return terms.every((t) => hay.includes(t));
}
